// Token costs per operation. Kept in sync with billing/services.py —
// STORY_GENERATION_COST and HERO_UPLOAD_COST. Hardcoded on the frontend
// because these values don't vary by plan today.
export const STORY_COST = 20;
export const HERO_COST = 1;
